import { render, staticRenderFns } from "./Septagon.vue?vue&type=template&id=46f56e48&"
import script from "./Septagon.vue?vue&type=script&lang=js&"
export * from "./Septagon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports